import script from "./BreadCrumbs.vue?vue&type=script&lang=ts&setup=true"
export * from "./BreadCrumbs.vue?vue&type=script&lang=ts&setup=true"

import "./BreadCrumbs.vue?vue&type=style&index=0&id=65acfaa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65acfaa0"]])

export default __exports__